module.exports = __webpack_public_path__ + "static/coworking_-6e09a0d6cf358411318db3699f758c42.svg";